import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import ModalX from '../../../../../../common/svgs/ModalX';
import { RetrievalButton } from '../../../../../../common/components/c_SourceSimpleFileInput';
import { isEmpty, flatMap, orderBy, filter } from 'lodash';

import {lookup} from '../../../../../../redux/helpers/staticData';

@connect((store) => {
  const company = store.admin.company;
  return {
    staticData: store.staticData,
    jobRequests: orderBy(filter(store.companyJobRequests, (job) => job.jobRequestStatus > 1 && job.companyId == company.id), ['dateCreated', 'dateAuthorized'], ['desc', 'desc'])
  }
})
export default class CompanyDocuments extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeDocuments: PropTypes.func.isRequired,
  };


  renderDocument = (document) => {

      return (
        <RetrievalButton
          className='file-get'
          loadingClass=''
          notLoadingClass=''
          failureClass=''
          autoLoad
          noMessage
          path={document.storagePath}
          signingRoute='/api/s3/get-sign'
        >
          <div  className='document-container'>
            <div className='document-name'>{document.fileName}</div>
            <div className='document-desc-container'>
              <div className='document-desc'>{document.description}</div>
              <div className='document-filesize'> {`${Math.max(Math.round(document.fileSize/100000)/10, 0.1)} Mgb`}</div>
            </div>
          </div>
        </RetrievalButton>
      );
  }

  renderJobConfirmation = (job) => {
    return (
      <div  className='document-container'>
        <div className='document-name'>ID#:{job.id} {lookup(this.props.staticData, 'positionTypes', {id:job.positionTypeId})}</div>
        <div className='document-desc-container'>
          <div className='document-desc'>{job.primaryContact}</div>
          <a className='document-button hover-link' href={`/admin/jobrequests/${job.id}/confirmation`} target={'_blank'}> VIEW </a>
        </div>
      </div>
    );
  }

  render() {

    return (
      <div className='worksheet-documents'>
        <div className='worksheet-documents-container'>
        <h1 className='heading'>Available Documents <ModalX onClick={this.props.closeDocuments } style={{color: '#000'}} className='close-button' /></h1>

          { !isEmpty(this.props.documents) ?
              this.props.documents.map((document) => this.renderDocument(document)  )
              :
              <p>No Documents Have Been Uploaded Yet</p>
          }

          <h1 className='heading'>Job Request Documents </h1>
          { !isEmpty(this.props.jobRequests) ? flatMap(this.props.jobRequests, (job) => this.renderJobConfirmation(job))
            :
            <p>No Job Requests Have Been Created Yet</p>
          }

          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Header/Documents/index.js